/**
 * PublicFooter — shared footer for all public-facing pages.
 *
 * Shows links to Terms of Service and Privacy Policy, keeping
 * the app legally compliant and discoverable from every public route.
 */
import { Link } from "react-router-dom";

interface PublicFooterProps {
  /** Extra Tailwind classes to add to the outer wrapper (e.g. for spacing) */
  className?: string;
}

export function PublicFooter({ className = "" }: PublicFooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer
      className={`w-full border-t border-border/40 bg-background/80 py-4 px-6 ${className}`}
    >
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-2 sm:flex-row sm:justify-between">
        {/* Brand */}
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Link to="/" className="flex items-center hover:opacity-100 transition-opacity" aria-label="Stratakey home">
            <img src="/logo.png" alt="Stratakey" className="h-5 w-auto object-contain opacity-90 hover:scale-105 transition-transform" />
          </Link>
          <span>&copy; {year}</span>
        </div>

        {/* Legal links */}
        <nav className="flex items-center gap-4 text-xs text-muted-foreground">
          <Link
            to="/terms"
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline"
          >
            Terms of Service
          </Link>
          <span className="text-border">·</span>
          <Link
            to="/privacy"
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline"
          >
            Privacy Policy
          </Link>
          <span className="text-border">·</span>
          <a
            href="mailto:info@stratakey.ca"
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline"
          >
            Support
          </a>
        </nav>
      </div>
    </footer>
  );
}
